import { TIME_DEFAULT, NUMBER_PATTERN, MAX_VALUE_LIST, TIME_PERIOD } from './constants';

export const timeCorrection = (timeNumber) => {
  const timeString = timeNumber.toString();
  return timeString.length === 1 ? '0' + timeString : timeString;
};

export const getPropsTime = (startDayTime, endDayTime) => {
  if (!startDayTime || !endDayTime) {
    return TIME_DEFAULT;
  }

  return {
    start: {
      hours: timeCorrection(startDayTime.getHours()),
      minutes: timeCorrection(startDayTime.getMinutes())
    },
    end: {
      hours: timeCorrection(endDayTime.getHours()),
      minutes: timeCorrection(endDayTime.getMinutes())
    }
  };
};

export const getTime = (dayTime) => ({
  start: {
    hours: timeCorrection(dayTime.start.hours),
    minutes: timeCorrection(dayTime.start.minutes)
  },
  end: {
    hours: timeCorrection(dayTime.end.hours),
    minutes: timeCorrection(dayTime.end.minutes)
  }
});

export const datesComparison = (day1, day2) => {
  if (!day1 || !day2) {
    return false;
  }

  return day1.getTime() === day2.getTime();
};

const daysRulesValidation = (name, value, period) => {
  if (name === 'minutes') {
    return true;
  }

  // Start day`s hours validate
  if (period === TIME_PERIOD.START && +value >= 24) {
    return false;
  }

  // End day`s hours validate
  if (period === TIME_PERIOD.END && +value >= 25) {
    return false;
  }

  return true;
};

export const timeValidation = ({ name, value }, hours, period = null) => {
  if (!NUMBER_PATTERN.test(value) && value.length > 0) {
    return false;
  }

  if ((name === 'hours' && +value > 24) || (name === 'minutes' && +value > 59)) {
    return false;
  }

  if (value[0]) {
    if (+value[0] > MAX_VALUE_LIST[name][0]) {
      return false;
    }
  }

  if (value[1]) {
    if (+value[1] > MAX_VALUE_LIST[name][1]) {
      return false;
    }
  }

  if (!daysRulesValidation(name, value, period)) {
    return false;
  }

  // Avoiding this case: TIME_PERIOD.END, 24:01
  if (period === TIME_PERIOD.END && name === 'minutes' && +hours === 24 && +value > 0) {
    return false;
  }

  return true;
};